// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';

const PrepareAuditAside = props =>
    <aside className='prepare-audit-aside'>
        <header>
            <FormattedMessage id='AUDIT_REQUIREMENT'/>
        </header>
        <div className='count'>
            <FormattedMessage id='USER_SELECTED'/>
            {props.count}
        </div>
    </aside>;

PrepareAuditAside.displayName = 'PrepareAuditAside';
PrepareAuditAside.propTypes = {
    count: PropTypes.number.isRequired
};

export default PrepareAuditAside;



// WEBPACK FOOTER //
// ./src/tcsm/prepare-audit/components/prepare-audit-aside.js